import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumenes" className="defer-paint w-full scroll-mt-6 bg-zinc-950 py-12 sm:py-14" aria-labelledby="volumes-heading" data-id="element-190" data-mp="cm526r4zghlj">
      <div className="mx-auto max-w-4xl px-6" data-id="element-191" data-mp="3g4pzd22fjizr">
        <SectionHeading eyebrow="Il sistema completo" title={<span id="volumes-heading" data-id="element-193" data-mp="3c45z3pmk7z9e">
              Il sistema completo che risolve tutto questo
            </span>} lead="6 volumi di allenamento tecnico + 5 bonus esclusivi. Apri qualsiasi volume per vedere cosa include." data-id="element-192" data-mp="3g5hhpb70nk83" />

        <ol className="mt-9 space-y-2.5" data-id="element-194" data-mp="3l3j2c0k3brlo">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-zinc-900 transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500/45' : 'border-zinc-800'}`} data-id="element-195" data-mp="2xcdmvmi2b1bw" data-mpi={index}>
                <h3 data-id="element-196" data-mp="29f8m2ygjjkvw">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-500 sm:px-6" data-id="element-197" data-mp="29dnzbv0gx68l">
                    <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border font-serif text-base font-bold transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500 bg-yellow-500 text-zinc-950' : 'border-yellow-500/35 bg-yellow-500/10 text-yellow-500'}`} aria-hidden="true" data-id="element-198" data-mp="1qho4mcg3volb">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-199" data-mp="3bur1ekks2e5g">
                      <span className="block font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400" data-id="element-200" data-mp="3bwbrny027axi">
                        Volume {index + 1}
                      </span>
                      <span className="mt-1 block font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-201" data-mp="1gsnjufbxs25n">
                        {volume.name}
                      </span>
                      <span className="mt-1 block font-sans text-[11px] uppercase tracking-[0.14em] text-yellow-500" data-id="element-202" data-mp="1ppeohg4k0pbu">
                        {volume.count}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-203" data-mp="x0h519olwmhi" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-204" data-mp="1226ggqfqr264">
                  <div className="overflow-hidden" data-id="element-205" data-mp="9dsmqmvoqs0d">
                    <div className="border-t border-zinc-800 px-5 py-5 sm:px-6" data-id="element-206" data-mp="9czcvd1fjme0">
                      <p className="font-sans text-[0.9rem] leading-relaxed text-stone-400" data-id="element-207" data-mp="2kz1hqclhrgke">
                        {volume.intro}
                      </p>

                      <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-208" data-mp="2c0g1io3hsdms">
                        <div className="rounded-2xl bg-zinc-800 p-4" data-id="element-209" data-mp="2by3brorhsyz6">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-red-400" data-id="element-210" data-mp="2gzitp7ydipdc">
                            Risolve
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-stone-200" data-id="element-211" data-mp="38ovtsrxzl13l">
                            {volume.solves}
                          </p>
                        </div>
                        <div className="rounded-2xl border border-yellow-500/25 bg-yellow-500/[0.07] p-4" data-id="element-212" data-mp="2znxm9zocabg9">
                          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-yellow-500" data-id="element-213" data-mp="1j9o11efe92tn">
                            Risultato
                          </p>
                          <p className="mt-2 font-sans text-[0.85rem] leading-relaxed text-stone-200" data-id="element-214" data-mp="23ljq9xiaonhr">
                            {volume.result}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}